/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {fileSrc} from '../fileUtils'
import {User} from '../../app/modules/apps/user/core/_models'

type Props = {
  user?: User
}

const colors = ['red', 'green', 'yellow', 'green', 'blue', 'gray']

export const UserInfoCell: FC<Props> = ({user}) =>
  user ? (
    <div className='flex items-center'>
      {/* Avatar */}
      <div className='relative flex-shrink-0 w-12 h-12 rounded-full overflow-hidden mr-3'>
        {user.image ? (
          <img
            src={fileSrc(user.image)}
            alt={user.first_name}
            className='object-cover w-full h-full'
          />
        ) : (
          <div
            className={clsx(
              'flex items-center justify-center w-full h-full text-white text-lg font-medium uppercase',
              `bg-${colors[Number(user.id) % 6]}-100`,
              `text-${colors[Number(user.id) % 6]}-700`
            )}
          >
            {user.first_name?.charAt(0).toUpperCase()}
          </div>
        )}
      </div>

      <div className='flex flex-col'>
        <span className='text-gray-800 hover:text-blue-600 font-medium mb-1'>
          {user.first_name} {user.last_name}
        </span>
        <span className='text-sm text-gray-500'>{user.email}</span>
      </div>
    </div>
  ) : null

export const TeacherInfoCell: FC<Props> = ({user}) => {
  if (!user) return null
  return (
    <div className='flex items-center'>
      <div className='flex flex-col'>
        <a href='#' className='text-gray-800 hover:text-blue-600 font-medium mb-1'>
          {user.first_name} {user.last_name}
        </a>
        <span className='text-sm text-gray-500'>{user.email}</span>
      </div>
    </div>
  )
}
